<div class="text-center">
  <mat-spinner style="margin:0 auto;" mode="indeterminate"></mat-spinner>
  <br>
  <h3>An error occurred. Please try again. If this problem persists, contact nSide for support.</h3>
</div>
